import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import type { PageHeaderSubcategoryStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";

const toCount = (raw: PageHeaderSubcategoryStoryblok["count"]): number | undefined => {
	if (raw === undefined || raw === null || raw === "") return undefined;
	const n = typeof raw === "number" ? raw : Number(raw);
	return Number.isFinite(n) ? n : undefined;
};

export const PageHeaderSubCategoryBlok = ({
	blok,
	darkMode,
}: BlokProps<PageHeaderSubcategoryStoryblok> & {
	darkMode?: boolean;
}) => {
	const href = sbLink(blok.link)?.href;
	return (
		<BlokWrap editable={blok}>
			{href ? (
				<Button
					as={Link}
					href={href}
					variant={darkMode ? "solid" : "outline"}
					color={darkMode ? "white" : "primary"}
					size="large"
					number={toCount(blok.count)}
					className="shrink-0"
				>
					{blok.label}
				</Button>
			) : (
				<Button
					variant={darkMode ? "solid" : "outline"}
					color={darkMode ? "white" : "primary"}
					size="large"
					number={toCount(blok.count)}
					className="shrink-0"
				>
					{blok.label}
				</Button>
			)}
		</BlokWrap>
	);
};
